import { CountryEntity } from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  CountryRiskBadges,
  CountryRiskField,
} from 'modules/client/common/feature';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/placeOfBirthForm';

export interface FormContentProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const FormContent = ({
  countriesLoading,
  countries,
}: FormContentProps) => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  return (
    <GridFields>
      <Field.Autocomplete
        showRequiredMark
        label={t('client.client.placeOfBirth.country.label')}
        loading={countriesLoading}
        name="placeOfBirth.country"
        optionLabelKey="name"
        options={countries}
        optionValueKey="id"
        placeholder={t('client.client.placeOfBirth.country.placeholder')}
        renderOptionRightAdornment={(option) => <CountryRiskBadges
          country={option as CountryEntity}
          field={CountryRiskField.PlaceOfBirth}
        />}
        rightStartElement={
          <CountryRiskBadges
            country={values.placeOfBirth?.country}
            field={CountryRiskField.PlaceOfBirth}
          />
        }
      />
      <Field.Text
        fullWidth
        showRequiredMark
        label={t('client.client.placeOfBirth.locality.label')}
        name="placeOfBirth.locality"
        placeholder={t('client.client.placeOfBirth.locality.placeholder')}
      />
    </GridFields>
  );
};
